import { MODULE as PARENT } from '../constants'

export const KEY = 'suggestions'
export const MODULE = [...[PARENT], KEY]
export const SET_QUERY = `${MODULE.join('/')}-set-query`
export const SET_CURRENT = `${MODULE.join('/')}-set-current`
export const FETCH_SUGGESTIONS = `${MODULE.join('/')}-fetch`
export const CLEAR_SUGGESTIONS = `${MODULE.join('/')}-clear`
